import { Component } from '@angular/core';

@Component({
  selector: 'app-hero',
  standalone: true,
  templateUrl: './hero.html',
  styleUrl: './hero.scss',
})
export class HeroComponent {
  scrollToTalleres() {
    const el = document.getElementById('talleres');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }
}
